import React, { useState } from 'react';
import { IconButtonProps } from '@rjsf/utils';
import { KatModal, KatButton } from '@amzn/katal-react';
import { RemoveButtonConstants } from '../../constants/ApplicationConstants';

/**
 * Renders a remove button action on a ArrayFieldTemplate
 * @see https://rjsf-team.github.io/react-jsonschema-form/docs/advanced-customization/custom-templates/#removebutton
 * @param props IconButtonProps
 * @returns Remove button layout with a confirmation modal.
 */
export const RemoveButton = (props: IconButtonProps) => {
  const { icon, iconType, uiSchema, ...btnProps } = props;
  const [visible, setVisible] = useState<boolean>(false);

  if (btnProps.disabled) {
    return null;
  }

  const removeButtonConfig = uiSchema?.['ui:placeholders']?.['ui:removeButton'];

  const confirmationModalTitle =
    removeButtonConfig?.['ui:confirmationModalTitle'] ??
    RemoveButtonConstants.CONFIRMATION_MODAL_TITLE;
  const confirmationSubmitButtonText =
    removeButtonConfig?.['ui:confirmationSubmitButtonText'] ??
    RemoveButtonConstants.CONFIRMATION_SUBMIT_BUTTON_TEXT;
  const confirmationModalText =
    removeButtonConfig?.['ui:confirmationModalText'] ??
    RemoveButtonConstants.CONFIRMATION_MODAL_TEXT;
  const removeButtonText =
    removeButtonConfig?.['ui:removeButtonText'] ??
    RemoveButtonConstants.REMOVE_BUTTON_TEXT;

  return (
    <>
      <KatModal
        title={confirmationModalTitle}
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        footer={
          <KatButton
            size="small"
            variant="primary"
            disabled={btnProps.disabled}
            onClick={(e: any) => btnProps.onClick!(e)}
          >
            {confirmationSubmitButtonText}
          </KatButton>
        }
      >
        {confirmationModalText}
      </KatModal>
      <KatButton
        data-testid="removeButtonTestId"
        size="small"
        variant="danger"
        disabled={btnProps.disabled}
        onClick={(e: any) => setVisible(true)}
      >
        {removeButtonText}
      </KatButton>
    </>
  );
};
